import { useEffect } from 'react';
import { APP_NAME } from './constant';
 
export function useDocumentTitle(title?: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    const metaTag = document.querySelector('meta[name="description"]');
    const prevDesc = metaTag?.getAttribute('content') ?? '';
 
    if (title) document.title = `${title} | ${APP_NAME}`;
    if (description && metaTag) metaTag.setAttribute('content', description);
 
    return () => {
      document.title = prevTitle;
      if (description && metaTag) metaTag.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}